export default {
  en: "English",
  nl: "Nederlands"
}